import React from 'react';
import { useLanguage } from '../context/LanguageContext';

export default function About() {
  const { t, setLanguage, language } = useLanguage();

  return (
    <section id="about" className="py-24 sm:py-32" data-testid="about-section">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Content */}
          <div>
            <span
              className="text-xs uppercase tracking-[0.2em] font-bold text-[#E31C25] block mb-4"
              data-testid="about-label"
            >
              {t('about.label')}
            </span>
            <h2
              className="text-3xl sm:text-4xl lg:text-5xl tracking-tight font-bold leading-tight mb-6"
              style={{ fontFamily: 'Outfit, sans-serif' }}
              data-testid="about-title"
            >
              {t('about.title')}
            </h2>
            <p className="text-base lg:text-lg leading-relaxed text-zinc-600 mb-6" data-testid="about-description">
              {t('about.description')}
            </p>
            <p className="text-base leading-relaxed text-zinc-500 border-l-4 border-[#008751] pl-6 italic" data-testid="about-mission">
              {t('about.mission')}
            </p>

            {/* Language badges */}
            <div className="flex flex-wrap gap-3 mt-8" data-testid="about-languages">
              {[
                { code: 'en', name: 'English' },
                { code: 'fr', name: 'Français' },
                { code: 'es', name: 'Español' },
                { code: 'pt', name: 'Português' },
              ].map((lang) => (
                <button
                  key={lang.code}
                  onClick={() => setLanguage(lang.code)}
                  className={`px-4 py-2 rounded-full border text-sm font-medium transition-colors ${
                    language === lang.code
                      ? 'border-[#008751] bg-[#008751]/10 text-[#008751]'
                      : 'border-zinc-200 text-zinc-700 bg-white hover:border-zinc-300'
                  }`}
                  data-testid={`about-lang-${lang.code}`}
                >
                  {lang.name}
                </button>
              ))}
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="rounded-3xl overflow-hidden aspect-[4/5] lg:aspect-[3/4]">
              <img
                src="https://customer-assets.emergentagent.com/job_ascifiw3-global/artifacts/jaxyrncl_generated-image.png"
                alt="Business owner"
                className="w-full h-full object-cover"
                data-testid="about-image"
              />
            </div>
            {/* Accent stripe */}
            <div className="absolute -bottom-4 -right-4 w-24 h-24 rounded-2xl bg-[#E31C25] -z-10" />
            <div className="absolute -top-4 -left-4 w-16 h-16 rounded-2xl bg-[#008751] -z-10" />
          </div>
        </div>
      </div>
    </section>
  );
}
